exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-form-group-control[data-v-518d6b4c]{height:100%}", ""]);

// exports
